module.exports = __webpack_public_path__ + "assets/img/news1.1.c314e57e.png";